// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-tab[data-v-e82c4590] .account-column {\n  text-align: center;\n}\n.account-tab[data-v-e82c4590] .account-column:hover {\n    color: blue;\n    font-weight: bold;\n    font-size: 12px;\n    border-bottom: 1px solid blue;\n}\n", ""]);
// Exports
module.exports = exports;
